import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as BuildingWizard } from "../../assets/icons/buildingWizard.svg";
import { ReactComponent as ContractWizard } from "../../assets/icons/contractsWizard.svg";
import { ReactComponent as SystemsWizard } from "../../assets/icons/systemsWizard.svg";
import { ReactComponent as ConsentWizard } from "../../assets/icons/consentWizard.svg";
import { ReactComponent as SystemsWizardPopup } from "../../assets/icons/systems-en-popup.svg";
import { ReactComponent as ContractWizardPopup } from "../../assets/icons/contractWizardPopup.svg";
import { ReactComponent as BuildingWizardAr } from "../../assets/icons/building_ar.svg";
import { ReactComponent as ContractWizardAr } from "../../assets/icons/contract_ar.svg";
import { ReactComponent as SystemsWizardAr } from "../../assets/icons/systems_ar.svg";
import { ReactComponent as ConsentWizardAr } from "../../assets/icons/consent_ar.svg";

import { ReactComponent as SystemsWizardPopupAR } from "../../assets/icons/arabic-systems-popup.svg";
import { ReactComponent as ContractWizardPopupAR } from "../../assets/icons/arabic-contract-popup.svg";

import "./AssignBuilding.scss";

import { useTranslation } from "react-i18next";
import { isArabic, isRtl } from "src/utils/helpers";

const AssignBuildingHeader = (params: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(["common", "user"]);
  const language = useSelector((state: any) => state.lookup.language);

  const assignBuilding = useSelector((state: any) => state.assignBuilding);

  const getHeader = (pageName: string) => {
    if (isRtl(language)) {
      if (pageName == "details") {
        return <BuildingWizardAr />;
      } else if (pageName == "contract") {
        return <ContractWizardAr />;
      } else if (pageName == "systems") {
        return <SystemsWizardAr />;
      } else if (pageName == "consent") {
        return <ConsentWizardAr />;
      }
    } else {
      if (pageName == "details") {
        return <BuildingWizard />;
      } else if (pageName == "contract") {
        return <ContractWizard />;
      } else if (pageName == "systems") {
        return <SystemsWizard />;
      } else if (pageName == "consent") {
        return <ConsentWizard />;
      }
    }
  };
  return (
    <div className="d-flex justify-content-center align-items-center mb-4 mt-0 w-100 p-0 assign-building-breadcrumb">
      {assignBuilding.currentStep === "details" && getHeader("details")}

      {assignBuilding.isContractPopupOpened &&
        assignBuilding.currentStep === "contract" &&
        (isArabic() ? (
          <div
            className="edit-contract-title-bg"
            style={{
              backgroundImage: `url(${require(`src/assets/images/edit-contract-title-bg.jpg`)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
            }}
          >
            <ContractWizardPopupAR />
          </div>
        ) : (
          <ContractWizardPopup />
        ))}
      {!assignBuilding.isContractPopupOpened &&
        assignBuilding.currentStep === "contract" &&
        getHeader("contract")}

      {assignBuilding.isSystemsPopupOpened &&
        assignBuilding.currentStep === "systems" &&
        (isArabic() ? (
          <div
            className="edit-contract-title-bg"
            style={{
              backgroundImage: `url(${require(`src/assets/images/edit-contract-title-bg.jpg`)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
            }}
          >
            <SystemsWizardPopupAR />
          </div>
        ) : (
          <SystemsWizardPopup />
        ))}

      {!assignBuilding.isSystemsPopupOpened &&
        !assignBuilding.isContractPopupOpened &&
        assignBuilding.currentStep === "systems" &&
        getHeader("systems")}

      {assignBuilding.currentStep === "consent" && getHeader("consent")}
    </div>
  );
};

export default AssignBuildingHeader;
